<template>
  <div id="hobbiesTile">  
    <div id="hobbies-container">
      <img
        id="hobbies-title"
        src="../assets/hobby-logo.png"
      />
      <div id="hobbies-roster">
        <div @mouseover="hover = 'anime'" class="hobbies-roster-item">
          <img       
            src="../assets/anime-logo.jpg"
            v-bind:class="{ active: hover=='anime' }"
          />
                  
        </div>
        <div @mouseover="hover = 'games'" class="hobbies-roster-item">
          <img       
            src="../assets/games-logo.jpg"
            v-bind:class="{ active: hover=='games' }"
          />          
        </div>
        <div @mouseover="hover = 'tech'" class="hobbies-roster-item">
          <img       
            src="../assets/tech-logo.jpg"
            v-bind:class="{ active: hover=='tech' }"
          />          
        </div>
        <div @mouseover="hover = 'friends'" class="hobbies-roster-item">
          <img       
            src="../assets/disco-logo.jpg"
            v-bind:class="{ active: hover=='friends' }"
          />          
        </div>        
      </div>
      <div id="hobbies-description">
        <div v-if="hover === 'anime'">
          <h2>{{hobbies["anime"]["title"]}}</h2>
          <span>{{hobbies["anime"]["info"]}}</span>
        </div>
        <div v-if="hover === 'games'">
          <h2>{{hobbies["games"]["title"]}}</h2>
          <span>{{hobbies["games"]["info"]}}</span>
        </div>
        <div v-if="hover === 'tech'">
          <h2>{{hobbies["tech"]["title"]}}</h2>
          <span>{{hobbies["tech"]["info"]}}</span>
        </div>
        <div v-if="hover === 'friends'">
          <h2>{{hobbies["friends"]["title"]}}</h2>
          <span>{{hobbies["friends"]["info"]}}</span>
        </div>
      </div>
    </div>

  </div>
  
</template>

<script>
import hobbies from "../static/hobbies.js";
export default {
  mounted: function() {},
  data() {
    return {
      hobbies: hobbies,
      hover: "anime",
    };
  },
};
</script>

<style>
@font-face {
  font-family: "mortal-kombat";
  src: url("../assets/fonts/mk2.ttf") format("truetype");
}


#hobbiesTile {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  height: fit-content;
  background-color: #2a9d8f;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#hobbies-title {
  position: absolute;
  width: 250px;
  top: -95px;
  transform: translateX(-50%);
  z-index: 2;
}

#hobbies-container{
  position: relative;
  width: 800px;
  height: fit-content;
  margin-top: 110px;
  display: inline-block;
  background-color: #212121;
  border-radius: 10px;
  box-shadow: -10px 10px 10px black;
}

#hobbies-roster{
  width: 20%;
  padding-top: 10px;
  padding-bottom: 10px;
  height: fit-content;
  float: left;
}
#hobbies-description{
  color: white;
  padding-top: 30px;
  margin-right: 30px;
  height: fit-content;
  flex-grow:1;
  text-align: left;
  font-family: "mortal-kombat";
}

#hobbies-description h2{
  font-weight: 700;
  color: #ffff00;
  font-size: 60px;
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    1px 1px 0 black, -4px 4px white;
}

#hobbies-description span{
  font-size: 35px;  
}

.hobbies-roster-item{
  height: 100px;
  margin: 3px;
}
.hobbies-roster-item img{
  height: 100%;
  cursor: pointer;
  filter: grayscale(100%);
}
.hobbies-roster-item img.active{
  animation: blink 0.5s step-end infinite;
  filter: none;
}

@keyframes blink {
  30% {
    box-shadow: 0 0 0 3px red;
  }
}

@media (min-width: 320px) and (max-width: 850px) {

  #hobbies-container{
    width: 95vw;
  }
  #hobbies-roster{
    padding-top: 30px ;
    padding-bottom: 0;
    width: 100%;
    float: none;
  }

  .hobbies-roster-item{
    max-width: 20%;
    margin: 1.5px;
    padding: 0px;
    display: inline-block;
  }
  .hobbies-roster-item img{
    width: 100%;
    height: auto;
    filter: grayscale(100%);
  }
  #hobbies-description{
    float: none;
    padding-top: 0;
    margin-left: 20px;
    margin-bottom: 20px
  }
  #hobbies-description h2{
    font-size: 45px;
  }
  #hobbies-description span{
    font-size: 25px;
  }

}
</style>
